import { render, staticRenderFns } from "./varietal.vue?vue&type=template&id=aab1eb44"
import script from "./varietal.vue?vue&type=script&lang=js"
export * from "./varietal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports